import { useCallback } from 'react';
import { usePanelIdentity } from '../common';
import { handleAction, TBasicAction } from './basicAction';

export const useActionEventHandlers = () => {
  const identifier = usePanelIdentity();

  const onClick = useCallback(
    (ev: React.MouseEvent<HTMLElement, MouseEvent>) => {
      return (action: TBasicAction) => {
        if (action.actionSource !== 'CLICK') return;
        handleAction(identifier, ev, action);
      };
    },
    [identifier],
  );

  const onDoubleClick = useCallback(
    (ev: React.MouseEvent<HTMLElement, MouseEvent>) => {
      return (action: TBasicAction) => {
        if (action.actionSource !== 'DOUBLE_CLICK') return;
        handleAction(identifier, ev, action);
      };
    },
    [identifier],
  );

  const onKeyDown = useCallback(
    (ev: React.KeyboardEvent<HTMLElement>) => {
      return (action: TBasicAction) => {
        if (ev.code !== 'Enter') return;
        handleAction(identifier, ev, action);
      };
    },
    [identifier],
  );

  return { onClick, onDoubleClick, onKeyDown };
};
